import axios from "axios";
// import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  getCommodeApi: root + "/Public/getCommodeApi",
  getMarketer: root + "/Public/getMarketerApi",
  schoolClientRerport: root + "/Report/schoolClientRerport",
  marketerClientReport: root + "/Report/marketerClientReport",
  channelClientReport: root + "/Report/channelClientReport",
  schoolMothReport: root + "/Report/schoolMothReport",
  marketerMothRrport: root + "/Report/marketerMothRrport",
  channelConsult: root + "/Report/channelConsult",
  getSource: root + "/Public/getSourceApi",
  getChannel: root + "/Public/getChannelApi",
  detailsByChannel: root + "/Report/detailsByChannel",
  gainsByChannel: root + "/Report/gainsByChannel",
  getClientHighestReport: root + "/Report/getClientHighestReport",
  getReportClientListApi: root + "/Report/getReportClientListApi",
  courseTypeApi: root + "/Public/courseTypeApi",
  trackDetailByLinkType: root + "/Report/trackDetailByLinkType",
  activityPositiveReport: root + "/Report/activityPositiveReport",
  activityClientList: root + "/Report/activityClientList",
  getAllCourseTypeApi: root + "/Public/getAllCourseTypeApi",
  // addClient:root+"/Client/addClientAction",
};
const storeanalysisreport = {
  getCommodeApi(params) {
    return axios.get(url.getCommodeApi, { params });
  },
  getMarketer(params) {
    return axios.get(url.getMarketer, { params });
  },
  trackDetailByLinkType(params) {
    return axios.get(url.trackDetailByLinkType, { params });
  },
  trackDetailByLinkType1() {
    return url.trackDetailByLinkType;
  },
  activityPositiveReport(params) {
    return axios.get(url.activityPositiveReport, { params });
  },
  activityPositiveReport1() {
    return url.activityPositiveReport;
  },
  activityClientList(params) {
    return axios.get(url.activityClientList, { params });
  },
  activityClientList1() {
    return url.activityClientList;
  },
  //Crn报表->获取校园追踪大表-lujing
  getClientHighestReport(params) {
    return axios.get(url.getClientHighestReport, { params });
  },
  getClientHighestReport1() {
    return url.getClientHighestReport;
  },
  //CRM报表->追踪大表->根据字段获招生详情-lujing
  getReportClientListApi(params) {
    return axios.get(url.getReportClientListApi, { params });
  },
  //Crm报表->渠道招生明细表
  detailsByChannel(params) {
    return axios.get(url.detailsByChannel, { params });
  },
  getAllCourseTypeApi(params) {
    return axios.get(url.getAllCourseTypeApi, { params });
  },
  detailsByChannel1() {
    return url.detailsByChannel;
  },
  //Crm报表->渠道业绩报表
  gainsByChannel(params) {
    return axios.get(url.gainsByChannel, { params });
  },
  gainsByChannel1() {
    return url.gainsByChannel;
  },
  //Crm报表->学校招生咨询报表
  schoolClientRerport(params) {
    return axios.get(url.schoolClientRerport, { params });
  },
  // 招生个人业绩统计表
  marketerClientReport(params) {
    return axios.get(url.marketerClientReport, { params });
  },
  //渠道业绩统计表
  channelClientReport(params) {
    return axios.get(url.channelClientReport, { params });
  },
  //CRM报表->校招生月度统计报表
  schoolMothReport(params) {
    return axios.get(url.schoolMothReport, { params });
  },
  //CRM报表->个人招生月度业绩统计报表
  marketerMothRrport(params) {
    return axios.get(url.marketerMothRrport, { params });
  },
  // CRM报表->渠道咨询报表
  channelConsult(params) {
    return axios.get(url.channelConsult, { params });
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params,
    });
  },
  // 获取招生渠道明细
  getChannel(params) {
    return axios.get(url.getChannel, {
      params,
    });
  },
  // 获取班组下拉
  courseTypeApi(params) {
    return axios.get(url.courseTypeApi, {
      params,
    });
  },
  schoolClientRerport1() {
    return url.schoolClientRerport;
  },
  marketerClientReport1() {
    return url.marketerClientReport;
  },
  channelClientReport1() {
    return url.channelClientReport;
  },
  schoolMothReport1() {
    return url.schoolMothReport;
  },
  marketerMothRrport1() {
    return url.marketerMothRrport;
  },
  channelConsult1() {
    return url.channelConsult;
  },
  // // 转为招生线索或无意向
  // changeIntentionClient(params){
  //   return axios.post(url.changeIntentionClient,qs.stringify(params))
  // },
};

export default storeanalysisreport;
